(function () {
    // Output
    const outputSidebarAjax = document.getElementById("filter-output");

    // Checkbox click event
    let checkBox = document.querySelectorAll(".sidebar-filter .checkbox");

    let listType = '';
    if( outputSidebarAjax ) {
        listType = outputSidebarAjax.dataset.type;
    }
    
    // Ensure only one checkbox can be selected at a time
    checkBox.forEach(function (checkbox) {
        checkbox.addEventListener("click", function () {
        // Uncheck all other checkboxes in the same category
        let categoryCheckboxes = checkbox
            .closest(".categories")
            .querySelectorAll("input[type=checkbox]");
        categoryCheckboxes.forEach(function (otherCheckbox) {
            if (otherCheckbox !== checkbox) {
            otherCheckbox.checked = false;
            }
        });
        document.getElementById("woocommerce-product-search-field").value = "";

        ajaxSidebarSrollToSection();
        filterProduct();
        });
    });

    // Clear filter
    let clearFilter = document.getElementById("clear-ajax-sidebar");
    if (clearFilter) {
        // Pagination function
        clearFilter.addEventListener("click", function () {
            ajaxSidebarSrollToSection();
            // Iterate through each checkbox and uncheck it
            checkBox.forEach(function (item) {
                item.checked = false;
            });

            filterProduct();
            // Ensure header updates to show "Products" as the title or listtype
            document.querySelector(".filter-header-title").textContent = listType || "Products";
        });
    }

    function pagination() {
        let pagination = document.querySelectorAll(".pagination .page-link");
        for (let i = 0; i < pagination.length; i++) {
        pagination[i].addEventListener("click", function (e) {
            e.preventDefault();
            let pageNo = pagination[i].getAttribute("data-pageno");

            filterProduct(pageNo);
            // delay scroll to ensure the content has updated
            setTimeout(() => {
            ajaxSidebarSrollToSection();
            }, 300);
        });
        }
    }
    pagination();
    // update filter header  category name and  total number of  selected category  products
    function updateFilterHeader() {
        let totalProductsElement = document.getElementById("e-filter-posts");
        let categoryNameElement = document.getElementById("e-category-posts");
        let startProduct = document.getElementById("start-product");
        let endProduct = document.getElementById("end-product");

        let totalProducts = totalProductsElement ? totalProductsElement.value : "0";
        let categoryName =
        categoryNameElement && categoryNameElement.value.trim() !== ""
            ? categoryNameElement.value
            : "Products";

        let filterTitle = document.querySelector(".filter-header-title");
        let totalCount = document.querySelector(".total-count");

        if (filterTitle) {
        filterTitle.textContent = categoryName;
        }

        if (
        totalProductsElement ||
        categoryNameElement ||
        startProduct ||
        endProduct
        ) {
        if (totalCount) {
            totalCount.textContent = `Showing ${startProduct.value}-${endProduct.value} of ${totalProducts} products`;
        }
        } else {
        totalCount.textContent = "No product found";
        }
    }

    // Filter product function
    function filterProduct(page = 1, searchTerm = "", postType = "product") {
        ajaxSidebarLoaderShow();

        let categoriesChoices = {};

        // Getting values from categories checkbox
        let categories = document.querySelectorAll(
        ".filter.sidebar-filter .categories input[type=checkbox]"
        );
        for (let i = 0; i < categories.length; i++) {
        if (categories[i].checked) {
            if (!categoriesChoices.hasOwnProperty(categories[i].name))
            categoriesChoices[categories[i].name] = [categories[i].value];
            else categoriesChoices[categories[i].name].push(categories[i].value);
        }
        }

        // Categories data to send in request
        let categoriesData = "";
        for (let key in categoriesChoices) {
        if (categoriesChoices.hasOwnProperty(key)) {
            let categoriesArray = categoriesChoices[key];

            for (let i = 0; i < categoriesArray.length; i++) {
            categoriesData +=
                "&categoriesChoices%5B" + key + "%5D%5B%5D=" + categoriesArray[i];
            }
        }
        }

        let clearBtnDisplay;
        if (categoriesData == "") {
        clearBtnDisplay = "none";
        } else {
        clearBtnDisplay = "block";
        }
        if (document.getElementById("clear-ajax-sidebar")) {
        document.getElementById("clear-ajax-sidebar").style.display =
            clearBtnDisplay;
        }

        // Page data to send in request
        let pageData = "&pageNo=" + page;
        let pageUrlValue = document.getElementById("page-url").value;
        let pageUrl = "&pageurl=" + pageUrlValue;

        // Add search term to the request
        let searchData = "&search_term=" + encodeURIComponent(searchTerm);
        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        request.onreadystatechange = () => {
        if (request.readyState === 4) {
            let responseHtml;
            if (request.response === "no-product") {
                responseHtml = '<span class="no-result">No Products Found</span>';
                ajaxSidebarLoaderHide();
            } else {
                responseHtml = request.response;
            }
            outputSidebarAjax.innerHTML = responseHtml;
            // Update filter header after AJAX success
            updateFilterHeader();

            pagination();

            ajaxSidebarLoaderHide();
        }
        };

        let parent = "&parent=" + encodeURIComponent(listType);
        request.send(
        "action=woocommerce_ajax_filter_products&nonce=" +
            ajax_callback_data.ajax_nonce +
            categoriesData +
            pageData +
            pageUrl +
            searchData +
            parent
        );
    }

    // On click open drop down filter
    let openFilter = document.getElementById("open-filter");
    if (openFilter) {
        openFilter.addEventListener("click", function () {
        let element = document.getElementById("product-filter");
        element.classList.toggle("d-block");
        openFilter.classList.toggle("open");
        });
    }

    function ajaxSidebarLoaderShow() {
        document.getElementById("loading").style.display = "flex";
    }

    function ajaxSidebarLoaderHide() {
        document.getElementById("loading").style.display = "none";
    }

    function ajaxSidebarSrollToSection() {
        let yOffset = -300; // Adjust this value to scroll more or less
        let SidebarScrollY =
        outputSidebarAjax.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: SidebarScrollY, behavior: "smooth" });
    }
    // search filter with validation
    let searchInput = document.getElementById("woocommerce-product-search-field");

    if (searchInput) {
        let validationMessage = document.getElementById("validation-message");

        if (!validationMessage) {
            validationMessage = document.createElement("div");
            validationMessage.id = "validation-message";
            validationMessage.style.color = "red";
            validationMessage.style.marginTop = "3px";
            validationMessage.style.position = "absolute";
            validationMessage.style.fontSize = "12px";
            searchInput.insertAdjacentElement("afterend", validationMessage);
        }

        searchInput.addEventListener("input", function () {
            let searchTerm = searchInput.value.trim();

            if (searchTerm.length > 0 && searchTerm.length < 3) {
                validationMessage.textContent = "Please enter at least 3 characters to search.";
            } else {
                validationMessage.textContent = "";
            }
        });

        document.getElementById("product-search").addEventListener("submit", function (e) {
            e.preventDefault();
            let searchTerm = searchInput.value.trim();

            if (searchTerm.length < 3) {
            validationMessage.textContent =
                "Please enter at least 3 characters to search.";
            } else {
            validationMessage.textContent = "";
            filterProduct(1, searchTerm); // Trigger the search
            }
        });
    }
})();